var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polyline, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobPhantesShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f98fff;}.cls-2{fill:#14635b;}.cls-3{fill:#283331;}.cls-4{fill:#1c7f78;}.cls-5{fill:#6ee5dc;}.cls-6{fill:aqua;}.cls-7{fill:#003834;}.cls-8{fill:#0f4c45;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "495.2 393.16 454.47 399.28 369.71 399.28 369.71 327.14 495.2 345.99 495.2 393.16"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "488.82 327.59 412.25 297.17 117.65 381.59 428.93 383.59 488.82 327.59"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "436.45 394.89 157.59 394.89 118.34 381.68 439.54 381.68 436.45 394.89"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "427.34 424.59 218.32 412.65 218.32 406.68 427.34 393.68 427.34 424.59"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "485.06 430.11 321.16 426.72 250.65 381.59 442.59 381.37 485.06 430.11"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "117.65 381.59 231.65 331.59 557.65 256.59"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "524.76 450.05 299.53 447.02 268.77 426.21 496.69 430.11 524.76 450.05"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "248.87 381.31 442.99 381.18 500.99 327.18 248.87 381.31"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "501.65 326.59 250.65 381.59 439.65 299.59 501.65 326.59"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.65 381.59 250.03 381.59 557.65 256.59 117.65 381.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobPhantesShip);
export default __webpack_public_path__ + "static/media/mob-phantes-ship.7287718f0510810dd09249c5b9fd0080.svg";
export { ForwardRef as ReactComponent };